import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Row } from '../layout';
import { Avatar } from '../avatar';
import { ListRowFeaturedCell } from './featured_cell';
export const TeamMember = ({ name, avatarUrl, }) => {
    return (_jsxs(Row, { alignItems: "center", children: [_jsx(Avatar, { src: avatarUrl ?? '', displayName: name ?? 'No Pro Found', size: "small", marginRight: '20px' }), _jsx(ListRowFeaturedCell, { headline: name ?? 'No Pro Found', subHeadline: "", maskHeadline: true })] }));
};
//# sourceMappingURL=team_member.js.map